
export class BottleSize {
  height;
  diameter;

  constructor (data = {}) {
    this.length = data.length || null
    this.diameter = data.height || null
  }
}
